import React from "react";

import {
    FaRupeeSign,
    FaShoppingCart,
    FaUsers,
    FaStore,
    FaUtensils,
    FaCreditCard,
} from "react-icons/fa";

import "../../styles/SummaryCards.css";

const SummaryCards = ({ stats = {} }) => {

    const cards = [

        {
            title: "Revenue",
            value: `₹${stats.totalRevenue || 0}`,
            subtitle: "Total Revenue",
            icon: <FaRupeeSign />,
        },

        {
            title: "Orders",
            value: stats.totalOrders || 0,
            subtitle: "Total Orders",
            icon: <FaShoppingCart />,
        },

        {
            title: "Customers",
            value: stats.totalCustomers || 0,
            subtitle: "Registered Customers",
            icon: <FaUsers />,
        },

        {
            title: "Providers",
            value: stats.totalProviders || 0,
            subtitle: "Active Providers",
            icon: <FaStore />,
        },

        {
            title: "Foods",
            value: stats.totalFoods || 0,
            subtitle: "Available Foods",
            icon: <FaUtensils />,
        },

        {
            title: "Payments",
            value: stats.totalPayments || 0,
            subtitle: "Successful Payments",
            icon: <FaCreditCard />,
        },

    ];

    return (

        <div className="summary-grid">

            {cards.map((card) => (

                <div
                    key={card.title}
                    className="summary-card"
                >

                    <div className="summary-icon">

                        {card.icon}

                    </div>

                    <div className="summary-content">

                        <h5>

                            {card.title}

                        </h5>

                        <h2>

                            {card.value}

                        </h2>

                        <p>

                            {card.subtitle}

                        </p>

                    </div>

                </div>

            ))}

        </div>

    );

};

export default SummaryCards;